import { Component, OnDestroy, OnInit } from '@angular/core';
import { FabNavItem } from '@fabric/components/common';
import { appNavItems } from './core/appNavItems';
import { caiNavItem } from './core/caiNavItem';
import { vehicleNavItems } from './core/vehicleNavItems';
import { FabUser } from './models/FabUser';
import { AuthenticationService } from './services/authentication.service';
import { SecurityService } from './services/security.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,OnDestroy{
  public readonly appName: string = 'Remitos';
  public sidenavVisible = true;
  public currentDate: Date = new Date();
  public isUserAuthorized:boolean=false;
  public user:FabUser;
  public navItems:FabNavItem[];
  private activeSessionIntervalId=0;
  private intervalDurationInMillis=5*60*1000;
  private inactivityDurationInMin=30;


  constructor(public securityService:SecurityService, private authenticationService:AuthenticationService) {
    console.log("app component constructor ");
  }

  ngOnInit(): void {
    console.log("app component init ");
    this.isUserAuthorized=this.securityService.isUserAuthorized;
    this.user=this.securityService.LOGGED_USER;
    if(this.isUserAuthorized){
      this.navItems=this.securityService.LOGGED_USER?.roleName?.toLowerCase().includes('cai_editor')?caiNavItem:
        ((this.securityService.LOGGED_USER.roleName?.toLowerCase().includes('vehicle')?vehicleNavItems:appNavItems));
    }
    this.activeSessionIntervalId = window.setInterval(() => {
      this.isUserSessionActive();
    }, this.intervalDurationInMillis);

  }

  toggleSideBar() {
    this.sidenavVisible = !this.sidenavVisible;
  }

  onSubmit(){
    this.authenticationService.logout();
  }

  isUserSessionActive() : void{
    if(this.securityService.LOGGED_USER){
      console.log("==================In set timeout ====================");
      let lastAccessTime=this.securityService.LOGGED_USER.lastAccessedTime;
     // console.log("=== last Access Time === ",lastAccessTime);
      let currentTime=new Date();
     // console.log("=== current time === ", currentTime);
      let lastAccessTimeInMin=lastAccessTime?.getMinutes();
      let currentTimeInMin=currentTime.getMinutes();
      //console.log("== last Access Time minute === ",lastAccessTimeInMin);
      //console.log("== current Time minute === ",currentTimeInMin);
      if(lastAccessTime){
        // @ts-ignore
        let diff=currentTimeInMin-lastAccessTimeInMin;
        console.log("==== diff in minute ====",diff);
        if(Math.abs(diff) >= this.inactivityDurationInMin ){
          //console.log(" diff > inactive period , logout user");
          this.authenticationService.logout();
        }
      }
    }
  }

  ngOnDestroy(): void {
    if(this.activeSessionIntervalId){
      clearInterval(this.activeSessionIntervalId);
    }
  }


}
